<template>
  <tr>
    <td>
      <router-link :to="{name: 'InvoicePage', params: {invoiceId: item.id}}">
        {{item.id}}
      </router-link>
      <export-invoice-as-excel
        :invoice-id="item.id"
        :client-id="item.clientId"
        :cost-center-id="item.costCenterId"
        :region-id="item.regionId"
        :short-version="true"
      />
    </td>
    <td>
      <client-info
        :title="costCenterTitle"
        :client-id="item.clientId"
        :short-title-length="50"
      />
    </td>
    <td>
      {{item.from | DateWithMinutes}}
    </td>
    <td>
      {{item.to | DateWithMinutes}}
    </td>
    <td>
      {{item.additionalInfo.casesAdded}}
    </td>
    <td>
      <pretty-amount :amount="item.additionalInfo.sumPrice"/>
    </td>
    <td>
      {{item.status}}
    </td>
    <td>
      <v-layout>
        <v-flex xs2 v-if="item.status === 'Draft'">
          <update-invoice-form :current-from="item.from"
                               :current-to="item.to"
                               :invoice-id="item.id"
                               :client-id="item.clientId"
                               :cost-center-id="item.costCenterId"
                               :region-id="item.regionId"/>
        </v-flex>
        <v-flex xs2 v-if="item.additionalInfo.casesAdded === 0">
          <delete-invoice-form :invoice-id="item.id"/>
        </v-flex>
        <v-flex xs2>
          <modal-json-view :json-data="item">
            <template slot="header">
              Data
            </template>
          </modal-json-view>
        </v-flex>
      </v-layout>
    </td>
  </tr>
</template>

<script>
  import ClientShortInfo from "../../Ui/mcc/ClientShortInfo";
  import AsyncData from "../../Ui/AsyncData";
  import ClientInfo from "../../Sales/case/ClientInfo";
  import DateWithMinutes from '../../Filters/DateWithMinutes'
  import NoEmpty from '../../Filters/NoEmpty'
  import ModalJsonView from "../../Ui/ModalJsonView";
  import ExportInvoiceAsCsv from "./ExportInvoiceAsCsv";
  import PrettyAmount from "../../Ui/PrettyAmount";
  import DeleteInvoiceForm from "./DeleteInvoiceForm";
  import ExportInvoiceAsExcel from "./ExportInvoiceAsExcel";
  import UpdateInvoiceForm from "./UpdateInvoiceForm";

  import {mapState} from 'vuex'

  export default {
    name: 'invoices-list-item',
    components: {
      ExportInvoiceAsExcel,
      AsyncData,
      ClientInfo,
      ModalJsonView,
      ClientShortInfo,
      ExportInvoiceAsCsv,
      PrettyAmount,
      DeleteInvoiceForm,
      UpdateInvoiceForm
    },
    filters: {
      NoEmpty,
      DateWithMinutes
    },
    props: {
      item: {
        type: Object,
        required: true,
      }
    },
    data() {
      return {}
    },
    computed: {
      ...mapState({
        allRegionsMap: 'allRegionsMap',
        allCostCentersMap: 'allCostCentersMap'
      }),
      costCenterTitle() {
        // Created by costCenter && regionId
        if (this.item.clientId === '00000000-0000-0000-0000-000000000000') {
          const costCenter = this.allCostCentersMap[this.item.costCenterId]
          const region = this.allRegionsMap[this.item.regionId]
          if (!costCenter || !region) {
            return '-'
          }
          return `${costCenter} - ${region}`
        }
        return ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/InvoiceListItem.vue